import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import HttpBackend, { HttpBackendOptions } from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

import ls, { localKeys } from "@services/localStorage"

const getLanguageFromLocalStorage = (): string => {
  return ls.getItem(localKeys.LANGUAGE) || "en" // Default to "en" if not set
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    fallbackLng: "en",
    lng: getLanguageFromLocalStorage(),
    ns: [
      "apiSettings",
      "auth",
      "components",
      "customDocuments",
      "customForms",
      "customLabels",
      "customTabs",
      "equipment",
      "formErrors",
      "integrations",
      "inventory",
      "itemProduction",
      "mo",
      "multipleOrdersPackingSlip",
      "orderItems",
      "packedItems",
      "planning",
      "production",
      "quotes",
      "receivingV2",
      "reporting",
      "settingsModal",
      "shipping",
      "snackbar",
      "tables",
      "tools",
      "translation",
      "wo",
    ],
    defaultNS: "translation",
    saveMissing: true,
  })

export default i18n
